import { SnackbarProvider } from "notistack"

export const withSnackbar = (Component: React.ComponentType) => () => {
  return (
    <SnackbarProvider maxSnack={3}>
      <Component />
    </SnackbarProvider>
  )
}
